import { Link } from 'react-router-dom';

export default function MidPageCTA() {
  return (
    <section className="relative py-20 overflow-hidden bg-forest">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.1) 0px, rgba(255,255,255,0.1) 1px, transparent 1px, transparent 20px)' }}>
      </div>

      {/* Decorative left line */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gold opacity-60"></div>

      <div className="relative max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-8">
        {/* Left */}
        <div className="text-center lg:text-left">
          <p className="text-gold text-[11px] font-semibold tracking-[0.28em] uppercase mb-3 flex items-center gap-3 justify-center lg:justify-start">
            <span className="h-px w-6 bg-gold inline-block"></span>
            Ready to Get Started?
          </p>
          <h2 className="font-serif text-white font-bold leading-tight" style={{ fontSize: 'clamp(28px, 3vw, 42px)' }}>
            Your Dream Outdoor Space<br />Is One Call Away.
          </h2>
        </div>

        {/* Right */}
        <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
          <a
            href="tel:3863014399"
            className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/25 text-white font-semibold text-sm px-7 py-4 rounded-full hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-fill text-gold"></i>
            (386) 301-4399
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-gold text-charcoal font-bold text-sm px-8 py-4 rounded-full hover:bg-gold-light transition-colors whitespace-nowrap"
          >
            <i className="ri-pencil-ruler-2-line"></i>
            Request a Design Consultation
          </Link>
        </div>
      </div>
    </section>
  );
}
